module.exports = __webpack_public_path__ + "static/media/interview_transcript_flat.eb793e67.png";